<template>
  <div class="content-box">
    <el-card class="box-card">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="VIN : ">
          <el-input v-model="formInline.vin" size="mini" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="备注 : ">
          <el-input v-model="formInline.remark" size="mini" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="时间范围 : ">
          <el-date-picker
              v-model="formInline.time"
              size="mini"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchTableData(1)" type="primary" size="mini">查询</el-button>
          <el-button @click="searchTableData(2)" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
      <el-button :loading="downloadType" @click="downloadFile" size="mini" style="width: 100px;margin-bottom: 20px">下
        载
      </el-button>
      <el-button @click="deleteFile" size="mini" style="width: 100px;margin-bottom: 20px">
        删除
      </el-button>
      <el-table
          row-key="id"
          v-loading="tableLoadingType"
          :height="tableHeight"
          ref="table"
          class="tableListValue"
          :data="tableData"
          stripe
          style="width: 100%">
        <el-table-column
            :reserve-selection="true"
            align="center"
            type="selection"
            width="50">
        </el-table-column>
        <el-table-column label="序号" type="index" width="60" align="center">
          <template #default="scope">
            <span v-text="getIndex(scope.$index)"></span>
          </template>
        </el-table-column>
        <el-table-column
            prop="vin"
            align="center"
            min-width="50"
            label="VIN">
        </el-table-column>
        <el-table-column
                prop="canChannel"
                align="center"
                width="80"
                label="CAN通道">
          <template slot-scope="scope">
            {{ canChannelObj[scope.row.canChannel] }}
          </template>
        </el-table-column>
        <el-table-column
            prop="powerOnTime"
            align="center"
            label="开始时间">
        </el-table-column>
        <el-table-column
            prop="powerOffTime"
            align="center"
            min-width="50"
            label="结束时间">
          <template slot-scope="scope">
            {{ scope.row.powerOffTime||'-' }}
          </template>
        </el-table-column>
        <el-table-column
                show-overflow-tooltip
                prop="remark"
                align="center"
                min-width="50"
                label="备注">
          <template slot-scope="scope">
            {{ scope.row.remark||'-' }}
          </template>
        </el-table-column>
        <el-table-column
                fixed="right"
                label="操作"
                width="100">
          <template slot-scope="scope">
            <el-button @click="editRemark(scope.row)" type="text" size="small">备注</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog
            title="添加备注"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
      <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="请输入内容"
              v-model="textarea2">
      </el-input>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="addRemark">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import {downASc, getDataHistoryDataPage,delDataHistoryData,updateDataHistoryDataRemark} from "../../common/downloadDataApi";
import {exportFile} from "../../utils/utils";

export default {
  name: "downloadData",
  data() {
    return {
      textarea2: '',
      remarkId: '',
      dialogVisible:false,
      loadingOverLay: null,
      canChannelObj: {
        0: '通道0',
        1: '通道1',
      },
      tableLoadingType: false,
      downloadType: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      formInline: {
        vin: '',
        remark: ''
      },
      tableHeight: 0,
      tableData: []
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 85
    })
    this.getDataHistoryDataPage()
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.textarea2 = ''
    },
    addRemark() {
      const data  = {
        id: this.remarkId,
        remark: this.textarea2
      }
      updateDataHistoryDataRemark(data).then(res=>{
        console.log(res)
        if (res.code === 200) {
          this.dialogVisible = false
          this.$notify.success({
            title: '操作成功 !',
            message: '备注添加成功!'
          })
          this.getDataHistoryDataPage()
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    editRemark(row) {
      console.log(row)
      this.dialogVisible = true
      this.remarkId = row.id
      if (row.remark) {
        this.textarea2 = row.remark
      }
    },
    getIndex(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    deleteFile() {
      let arr = this.$refs.table.selection;
      // console.log(arr)
      if (arr.length === 0) {
        this.$notify.error({
          title: '操作错误 !',
          message: '请选择数据后操作 !'
        })
        return false
      }
      if (arr.length > 1) {
        this.$notify.error({
          title: '操作错误 !',
          message: '只可选择一条数据后操作 !'
        })
        return false
      }
      delDataHistoryData({id:arr[0].id}).then(res=>{
        console.log(res)
        if (res.code === 200) {
          this.$notify.success({
            title: '操作成功 !',
            message: '删除成功!'
          })
           this.$refs.table.clearSelection()
          this.getDataHistoryDataPage()
        }
        console.log(arr)
      }).catch(err=>{
        console.log(err)
      })
    },
    // 下载文件
    async downloadFile() {
      // console.log(process.env)
      const arr = this.$refs.table.selection;
      if (arr.length === 0) {
        this.$notify.error({
          title: '操作错误 !',
          message: '请选择数据后操作 !'
        })
        return
      }
      if (arr.length > 1) {
        this.$notify.error({
          title: '操作错误 !',
          message: '只可选择一条数据后操作 !'
        })
        return
      }
      this.downloadType = true
      try {
        // const data = await downASc(arr[0].id)
        // console.log(downASc(arr[0].id))
        // this.loadingOverLay = this.$loading({
        //   lock: true,
        //   text: '文件生成中',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0,0,0,0.7)'
        // });
        let elemIF = document.createElement('iframe');
        elemIF.src = process.env.VUE_APP_BASE_API + 'bool/vehicle/downASc/?id='+arr[0].id;

        elemIF.style.display ='none';
        elemIF.onload = function(e) {
          console.log(e)
          // console.log('start downloading...');
          // document.body.removeAttribute(elemIF);
        }
        document.body.appendChild(elemIF);

        // this.loadingOverLay.close();
        // console.log(data)
        // let fileNames = data.headers['content-disposition'] //获取到Content-Disposition;filename
        // let regFileNames = fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称
        // // console.log(regFileNames)
        // if (data) {
        //   exportFile(data.data, decodeURI(regFileNames,'utf-8'))
        //   this.downloadType = false
        //   this.$refs.table.clearSelection();
        // } else {
        //   this.$notify.error({
        //     title: '错误提示',
        //     message: '导出数据失败 !'
        //   })
        setTimeout(()=>{
          this.downloadType = false
        },10000)

        // }
      } catch (e) {
        this.downloadType = false
        console.log(e)
      }
    },
    // 获取列表
    async getDataHistoryDataPage() {
      this.tableLoadingType = true
      try {
        const param = {
          vin: this.formInline.vin,
          remark: this.formInline.remark,
          startTime: this.formInline.time ? this.formInline.time[0] : '',
          endTime: this.formInline.time ? this.formInline.time[1] : '',
          pageNo: this.currentPage,
          pageSize: this.pageSize,
        }
        const res = await getDataHistoryDataPage(param)
        if (res.code === 200) {
          this.tableData = res.data
          this.total = res.total
          this.tableLoadingType = false
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          });
          this.tableLoadingType = false
        }
      } catch (e) {
        this.tableLoadingType = false
        console.log(e)
      }
    },
    // 搜索重置
    searchTableData(type) {
      if (type === 2) {
        this.formInline = {}
      }
      this.getDataHistoryDataPage()
    },
    handleSizeChange(e) {
      this.$refs.table.clearSelection()
      this.pageSize = e
      this.getDataHistoryDataPage()
    },
    handleCurrentChange(e) {
      // console.log('触发')
      this.$refs.table.clearSelection()
      this.currentPage = e
      this.getDataHistoryDataPage()
    },
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 10px;
  text-align: right;
}

.box-card {
  text-align: left;
  border-radius: 10px;
  height: 100%;
}
</style>
<style scoped lang="scss">
.tableListValue {
  //滚动条的宽高
  ::-webkit-scrollbar {
    width: 1vh;
    height: 1vh;
  }

  //滚动条的滑块背景色
  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2vh;
  }

  //滚动条的背景色
  ::-webkit-scrollbar-track {
    background: rgba(#ccc, 0.3);
  }

}


/* 设置滚动条的样式 */
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}


/*定义滚动条轨道 内阴影+圆角*/

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  background-color: #F5F5F5;
}


/*定义滑块 内阴影+圆角*/

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
  background-color: #ccc;

}

</style>
